export const meditationTypes = 
[
  {
    id: "one",
    name: "Focus on Your Goal Meditation",
    category: "Focus Meditation",
    steps: [
      "Sit in a comfortable position and close your eyes",
      "Take a few deep breaths to relax",
      "Visualize your goal with clarity and detail",
      "See yourself taking the necessary steps to achieve it",
      "Engage your senses and emotions in this visualization",
      "Stay focused on your goal for the duration of the meditation",
      "When you're ready, slowly open your eyes",
      "Take inspired action towards your goal",
    ],
    videoUrl: "https://youtu.be/4Nw8EmF-DqE",
    benefits: [
      "Enhances focus and concentration",
      "Increases motivation and determination",
      "Helps align your mindset with your goals",
    ],
    problems: [
      "Difficulty maintaining focus",
      "Lack of clarity in defining goals",
    ],
  },
  {
    id: "two",
    name: "Mindful Focus Meditation",
    category: "Focus Meditation",
    steps: [
      "Find a quiet and comfortable space to sit",
      "Gently close your eyes and take a few deep breaths",
      "Bring your attention to the present moment",
      "Notice the sensations in your body and the sounds around you",
      "Allow your thoughts to come and go without judgment",
      "Keep redirecting your focus to the present whenever your mind wanders",
      "Continue practicing mindful focus for the desired duration",
      "When you're ready, gently open your eyes",
    ],
    videoUrl: "https://youtu.be/iFpCeuA1mRs",
    benefits: [
      "Promotes mindfulness and presence",
      "Reduces distractions and improves concentration",
      "Enhances self-awareness and acceptance",
    ],
    problems: [
      "Restlessness and wandering thoughts",
      "Difficulty staying present without judgment",
    ],
  },
  {
    id: "three",
    name: "Inner Peace Meditation",
    category: "Inner Peace",
    steps: [
      "Find a quiet and comfortable place to sit",
      "Close your eyes and take several deep breaths",
      "Allow your body to relax with each exhale",
      "Bring your awareness to the present moment",
      "Silently repeat the affirmation 'I am peace'",
      "Feel the sense of calm and tranquility within",
      "Continue this practice for the desired duration",
      "When you're ready, gently open your eyes",
    ],
    videoUrl: "https://youtu.be/pAEioF7FaWY",
    benefits: [
      "Cultivates inner peace and serenity",
      "Reduces anxiety and stress",
      "Enhances emotional well-being",
    ],
    problems: [
      "Restless thoughts and difficulty quieting the mind",
      "Challenges in sustaining a peaceful state",
    ],
  },
  {
    id: "four",
    name: "Inner Peace and Meditation",
    category: "Inner Peace",
    steps: [
      "Find a comfortable position and close your eyes",
      "Take a deep breath and release any tension in your body",
      "Bring your attention to the sensation of relaxation",
      "Imagine a peaceful scene or visualize floating on a calm ocean",
      "Allow yourself to let go of any worries or stress",
      "Stay in this relaxed state for the duration of the meditation",
      "When you're ready, slowly open your eyes",
    ],
    videoUrl: "https://youtu.be/94IFuiy8TPM",
    benefits: [
      "Induces deep relaxation and calmness",
      "Promotes a sense of inner harmony",
      "Helps alleviate stress-related symptoms",
    ],
    problems: [
      "Restlessness and difficulty achieving deep relaxation",
      "Challenges in maintaining focus on peaceful imagery",
    ],
  },
  {
    id: "five",
    name: "Manifesting Peace Meditation",
    category: "Inner Peace",
    steps: [
      "Sit comfortably and take a few deep breaths",
      "Focus your attention on the feeling of peace within",
      "Visualize peace spreading throughout your body",
      "Expand your visualization to your surroundings and the world",
      "Hold the intention of manifesting peace in your life",
      "Continue to feel and radiate peace for the desired duration",
      "When you're ready, gently open your eyes",
      "Carry the energy of peace with you throughout the day",
    ],
    videoUrl: "https://youtu.be/9fr6geQtd88",
    benefits: [
      "Cultivates a sense of peace and harmony within",
      "Promotes a positive and peaceful mindset",
      "Enhances the ability to manifest peace in daily life",
    ],
    problems: [
      "Distractions and difficulties maintaining focus",
      "Challenges in connecting with the feeling of peace",
    ],
  },
  {
    id: "six",
    name: "Inner Peace Affirmation",
    category: "Inner Peace",
    steps: [
      "Find a comfortable seated position",
      "Close your eyes and take a few deep breaths",
      "Repeat the affirmation 'I am calm and at peace'",
      "Allow the words to sink into your being",
      "Feel the sense of inner peace growing within you",
      "Continue affirming for the desired duration",
      "When you're ready, gently open your eyes",
      "Carry the affirmation of inner peace with you",
    ],
    videoUrl: "https://youtu.be/F9ArAP7rz_U",
    benefits: [
      "Instills a sense of calm and tranquility",
      "Empowers a positive and peaceful mindset",
      "Reinforces a belief in inner peace and well-being",
    ],
    problems: [
      "Distractions and wandering thoughts",
      "Challenges in maintaining focus on the affirmation",
    ],
  },
  {
    id: "twenty-one",
    name: "Mindfulness Meditation",
    category: "Beginners",
    steps: [
      "Find a quiet place",
      "Sit comfortably",
      "Focus on your breath",
      "Observe your thoughts",
      "Return to your breath",
    ],
    benefits: [
      "Reduces stress",
      "Increases self-awareness",
      "Improves focus and concentration",
    ],
    problems: ["Restlessness", "Difficulty staying present"],
    videoUrl: "https://youtu.be/ssss7V1_eyA",
  },
  {
    id: 'twenty-two',
    name: "Transcendental Mantra Meditation for Grounding",
    category: "Anxiety",
    steps: [
      "Sit comfortably with eyes closed",
      "Repeat a mantra silently",
      "Allow thoughts to come and go",
    ],
    benefits: ["Promotes grounding", "Reduces anxiety", "Enhances clarity"],
    problems: ["Finding a suitable mantra", "Mental distractions"],
    videoUrl: "https://youtu.be/oxBSo9GwbtI",
  },
  {
    id: 'twenty-three',
    name: "Loving-Kindness Meditation",
    category: "Self-Care",
    steps: [
      "Sit comfortably",
      "Generate feelings of love and kindness",
      "Direct well-wishes towards yourself",
      "Extend well-wishes towards others",
    ],
    benefits: [
      "Cultivates compassion",
      "Increases positive emotions",
      "Improves relationships",
    ],
    problems: [
      "Difficulty generating loving feelings",
      "Challenging emotions may arise",
    ],
    videoUrl: "https://youtu.be/sDi40FQcaIU",
  },
  {
    id: 'twenty-four',
    name: "Om mantra",
    category: "Mantra Meditation",
    steps: [
      "Choose a sacred word or phrase",
      "Sit quietly and comfortably",
      "Repeat the sacred word or phrase",
      "Reflect and connect with the divine",
    ],
    benefits: [
      "Deepens spiritual connection",
      "Promotes inner peace",
      "Enhances self-awareness",
    ],
    problems: [
      "Distractions from the sacred focus",
      "Challenges in maintaining regular practice",
    ],
    videoUrl: "https://youtu.be/3mMqQXlCtTM",
  },
  {
    id: 'twenty-five',
    name: "Focused Meditation",
    category: "Focus Meditation",
    steps: [
      "Choose an object of focus",
      "Sit comfortably and relax",
      "Direct your attention to the chosen object",
      "Maintain focus and awareness",
    ],
    benefits: [
      "Improves concentration",
      "Enhances clarity and insight",
      "Reduces mental clutter",
    ],
    problems: [
      "Difficulty in sustaining focus",
      "Restlessness or wandering thoughts",
    ],
    videoUrl: "https://youtu.be/_z3mdzg_8Ss",
  },
  {
    id: 'twenty-six',
    name: "Movement Meditation",
    category: "Self-Care",
    steps: [
      "Engage in rhythmic and mindful movement",
      "Focus on the sensations and flow of movement",
      "Connect mind and body through movement",
      "Experience a sense of embodiment",
    ],
    benefits: [
      "Promotes physical well-being",
      "Increases body awareness",
      "Relieves tension and stress",
    ],
    problems: [
      "Finding suitable movement practices",
      "Physical limitations or discomfort",
    ],
    videoUrl: "https://youtu.be/byDU78tREco",
  },
  {
    id: 'seven',
    name: "Guided Meditation",
    category: "Inner Peace",
    steps: [
      "Choose a mantra or sacred sound",
      "Sit comfortably and close your eyes",
      "Repeat the mantra silently or aloud",
      "Let go of other thoughts and distractions",
    ],
    benefits: [
      "Calms the mind and nervous system",
      "Deepens focus and concentration",
      "Elevates spiritual vibrations",
    ],
    problems: [
      "Selecting an appropriate mantra",
      "Restlessness or mental chatter",
    ],
    videoUrl: "https://youtu.be/xv-ejEOogaA",
  },
  {
    id: 'eight',
    name: "Progressive Relaxation",
    category: "Stress",
    steps: [
      "Find a comfortable position",
      "Tense and relax different muscle groups",
      "Release tension and experience deep relaxation",
      "Focus on the sensations of relaxation",
    ],
    benefits: [
      "Reduces physical and mental tension",
      "Induces relaxation and calmness",
      "Improves sleep quality",
    ],
    problems: [
      "Difficulty in fully relaxing muscles",
      "Impatience or restlessness during practice",
    ],
    videoUrl: "https://youtu.be/WldO3nKFDJc",
  },
  
    {
      id: "nine",
      name: "10-Minute Meditation For Stress",
      category: "Stress",
      steps: [
        "Find a quiet and comfortable space",
        "Sit in a relaxed position",
        "Close your eyes and take a few deep breaths",
        "Allow your body and mind to relax",
        "Focus on your breath and let go of any tension or stress",
        "Continue breathing deeply for 10 minutes",
        "Open your eyes and take a moment to reflect"
      ],
    benefits: [
        "Reduces stress and anxiety",
        "Promotes calmness and relaxation",
        "Improves mental clarity and focus"
      ],
      problems: [
        "Difficulty in quieting the mind",
        "Restlessness during meditation"
      ],
      videoUrl: "https://youtu.be/z6X5oEIg6Ak"
    },
    {
      "id": "ten",
      name: "Meditation for Stress",
      category: "Stress",
      steps: [
        "Find a quiet and comfortable place",
        "Sit or lie down in a relaxed position",
        "Close your eyes and take a few deep breaths",
        "Bring your attention to your body and notice any areas of tension",
        "Scan your body from head to toe, releasing tension as you exhale",
        "Focus on your breath and allow your mind to become calm and still",
        "Continue for the desired duration",
        "Gently bring your awareness back to the present moment"
      ],
    benefits: [
        "Reduces stress and tension",
        "Enhances relaxation and well-being",
        "Promotes mental clarity and focus"
      ],
      problems: [
        "Restlessness or impatience",
        "Difficulty in quieting the mind"
      ],
      videoUrl: "https://youtu.be/Ix73CLI0Mo0"
    },
    {
      "id": "eleven",
      name: "Take a Stress Reduction Break",
      category: "Stress",
      steps: [
        "Find a comfortable position",
        "Close your eyes and take a deep breath",
        "Imagine a peaceful place and visualize yourself there",
        "Focus on the sights, sounds, and sensations of your imagined peaceful place",
        "Take slow, deep breaths and let go of any tension or stress",
        "Continue for a few minutes",
        "Open your eyes and return to the present moment"
      ],
    benefits: [
        "Relieves stress and anxiety",
        "Creates a sense of calm and relaxation",
        "Provides a mental break from stressors"
      ],
      problems: [
        "Difficulty in visualizing",
        "Restlessness or impatience"
      ],
      videoUrl: "https://youtu.be/R_yFAMtfv9c"
    },
    {
      "id": "twelve",
      name: "Guided Meditation for Stress Relief",
      category: "Stress",
      steps: [
        "Find a quiet and comfortable space",
        "Sit or lie down in a relaxed position",
        "Close your eyes and take a deep breath",
        "Follow the guided instructions to release stress and tension",
        "Focus on the sensations in your body and your breath",
        "Continue for the desired duration",
        "Slowly bring your awareness back to the present moment"
      ],
    benefits: [
        "Reduces stress and promotes relaxation",
        "Calms the mind and enhances well-being",
        "Improves sleep quality"
      ],
      problems: [
        "Restlessness or impatience",
        "Difficulty in fully relaxing"
      ],
      videoUrl: "https://youtu.be/uNiJW0KMwf4"
    },
    {
      "id": "thirteen",
      name: "Reframe Stress",
      category: "Stress",
      steps: [
        "Find a comfortable seated position",
        "Close your eyes and take a deep breath",
        "Acknowledge the presence of stress without judgment",
        "Shift your perspective and view stress as a challenge or opportunity for growth",
        "Breathe deeply and release any tension or negative thoughts",
        "Continue for a few minutes",
        "Open your eyes and embrace the new perspective"
      ],
    benefits: [
        "Helps change the mindset towards stress",
        "Promotes resilience and adaptability",
        "Enhances problem-solving abilities"
      ],
      problems: [
        "Difficulty in shifting the perspective",
        "Restlessness or impatience"
      ],
      videoUrl: "https://youtu.be/sG7DBA-mgFY"
    },
    {
    id: "fourteen",
    name: "Om Meditation",
    category: "Mantra Meditation",
    steps: [
      "Find a comfortable seated position",
      "Close your eyes and take a deep breath",
      "Chant the Om mantra repeatedly",
      "Focus your attention on the sound and vibration of Om",
      "Continue for a few minutes",
      "Take a final deep breath and slowly open your eyes"
    ],
    benefits: [
      "Promotes relaxation and inner peace",
      "Enhances focus and concentration",
      "Connects with the universal consciousness"
    ],
    videoUrl: "https://youtu.be/JEoxUG898qY"
  },
  {
    id: "fifteen",
    name: "Saraswati Mantra Meditation",
    category: "Mantra Meditation",
    steps: [
      "Find a quiet place and sit comfortably",
      "Close your eyes and take a few deep breaths",
      "Chant the Saraswati mantra: 'Om Aim Saraswatyai Namaha'",
      "Visualize the divine energy of Saraswati surrounding you",
      "Continue chanting for a few minutes",
      "Take a moment of silence to absorb the energy",
      "Open your eyes and carry the essence of Saraswati with you"
    ],
    benefits: [
      "Enhances creativity and knowledge",
      "Improves learning and memory",
      "Invokes the blessings of Saraswati, the goddess of wisdom"
    ],
    videoUrl: "https://youtu.be/4koR8WKxHmc"
  },
  {
    id: "sixteen",
    name: "Gayatri Mantra Meditation",
    category: "Mantra Meditation",
    steps: [
      "Find a comfortable posture and close your eyes",
      "Take a few deep breaths to relax",
      "Chant the Gayatri mantra: 'Om Bhur Bhuva Swaha, Tat Savitur Varenyam, Bhargo Devasya Dheemahi, Dhiyo Yo Nah Prachodayat'",
      "Reflect on the meaning and power of the mantra",
      "Continue chanting for a few minutes",
      "Experience the uplifting and purifying vibrations",
      "Open your eyes and carry the divine energy within you"
    ],
    benefits: [
      "Promotes spiritual growth and enlightenment",
      "Cultivates inner wisdom and clarity",
      "Invokes the divine light and blessings of Gayatri Devi"
    ],
    videoUrl: "https://youtu.be/6Kb0q9J8lPA"
  },
  {
    id: "seventeen",
    name: "Hanuman Mantra Meditation",
    category: "Mantra Meditation",
    steps: [
      "Find a quiet space and sit comfortably",
      "Close your eyes and take a few deep breaths",
      "Chant the Hanuman mantra: 'Om Hum Hanumate Namaha'",
      "Feel the presence and strength of Hanuman within you",
      "Continue chanting with devotion and sincerity",
      "Connect with the qualities of courage, devotion, and protection",
      "Open your eyes and carry Hanuman's blessings with you"
    ],
    benefits: [
      "Enhances courage and inner strength",
      "Offers protection from negativity and obstacles",
      "Invokes the blessings and guidance of Lord Hanuman"
    ],
    videoUrl: "https://www.youtube.com/live/q8IuE29hgXM?feature=share"
  },
  {
    id: "eighteen",
    name: "Shiv Mantra Meditation",
    category: "Mantra Meditation",
    steps: [
      "Sit in a comfortable position and close your eyes",
      "Take a few deep breaths to center yourself",
      "Chant the Shiv mantra: 'Om Namah Shivaya'",
      "Immerse yourself in the divine energy of Lord Shiva",
      "Continue chanting with devotion and surrender",
      "Feel the peace and transformation within",
      "Open your eyes and carry the grace of Lord Shiva"
    ],
    benefits: [
      "Promotes inner peace and spiritual growth",
      "Clears negative energy and purifies the mind",
      "Invokes the blessings and guidance of Lord Shiva"
    ],
    videoUrl: "https://youtu.be/X75aSH7Z8Cs"
  }
  ,{
  id: "nineteen",
    name: "2-Minute Focus Meditation",
    category: "Focus Meditation",
    steps: [
      "Find a quiet and comfortable place to sit",
      "Close your eyes and take a few deep breaths",
      "Bring your attention to your breath",
      "Focus on the sensation of each inhale and exhale",
      "If your mind wanders, gently bring it back to your breath",
      "Continue this practice for 2 minutes",
      "When you're ready, slowly open your eyes"
    ],
    videoUrl: "https://youtu.be/QtE00VP4W3Y"
  },
  {
    id: "twenty",
    name: "10-Minute Focus Meditation",
    category: "Focus Meditation",
    steps: [
      "Find a quiet and comfortable place to sit",
      "Close your eyes and take a few deep breaths",
      "Bring your attention to your breath",
      "Notice the sensation of each inhale and exhale",
      "If thoughts arise, acknowledge them and let them go",
      "Continue to focus on your breath for 10 minutes",
      "When the time is up, take a moment to sit in stillness",
      "Open your eyes and carry the focused state with you"
    ],
    videoUrl: "https://youtu.be/o_SHRA0oxRQ"
  },
  {
    id: "twenty-one",
    name: "Focus on Your Goal Meditation",
    category: "Focus Meditation",
    steps: [
      "Sit in a comfortable position and close your eyes",
      "Take a few deep breaths to relax",
      "Visualize your goal with clarity and detail",
      "See yourself taking the necessary steps to achieve it",
      "Engage your senses and emotions in this visualization",
      "Stay focused on your goal for the duration of the meditation",
      "When you're ready, slowly open your eyes",
      "Take inspired action towards your goal"
    ],
    videoUrl: "https://youtu.be/4Nw8EmF-DqE"
  },
  {
    id: "twenty-two",
    name: "Mindful Focus Meditation",
    category: "Focus Meditation",
    steps: [
      "Find a quiet and comfortable space to sit",
      "Gently close your eyes and take a few deep breaths",
      "Bring your attention to the present moment",
      "Notice the sensations in your body and the sounds around you",
      "Allow your thoughts to come and go without judgment",
      "Keep redirecting your focus to the present whenever your mind wanders",
      "Continue practicing mindful focus for the desired duration",
      "When you're ready, gently open your eyes"
    ],
    videoUrl: "https://youtu.be/iFpCeuA1mRs"
  }
  ,{
    id: "twenty-three",
    name: "Inner Peace Meditation",
    category: "Inner Peace",
    steps: [
      "Find a quiet and comfortable place to sit",
      "Close your eyes and take several deep breaths",
      "Allow your body to relax with each exhale",
      "Bring your awareness to the present moment",
      "Silently repeat the affirmation 'I am peace'",
      "Feel the sense of calm and tranquility within",
      "Continue this practice for the desired duration",
      "When you're ready, gently open your eyes"
    ],
    videoUrl: "https://youtu.be/pAEioF7FaWY"
  },
  {
    id: "twenty-four",
    name: " Inner Peace and Meditation",
    category: "Inner Peace",
    steps: [
      "Find a comfortable position and close your eyes",
      "Take a deep breath and release any tension in your body",
      "Bring your attention to the sensation of relaxation",
      "Imagine a peaceful scene or visualize floating on a calm ocean",
      "Allow yourself to let go of any worries or stress",
      "Stay in this relaxed state for the duration of the meditation",
      "When you're ready, slowly open your eyes"
    ],
    videoUrl: "https://youtu.be/94IFuiy8TPM"
  },
  {
    id: "twenty-five",
    name: "Manifesting Peace Meditation",
    category: "Inner Peace",
    steps: [
      "Sit comfortably and take a few deep breaths",
      "Focus your attention on the feeling of peace within",
      "Visualize peace spreading throughout your body",
      "Expand your visualization to your surroundings and the world",
      "Hold the intention of manifesting peace in your life",
      "Continue to feel and radiate peace for the desired duration",
      "When you're ready, gently open your eyes",
      "Carry the energy of peace with you throughout the day"
    ],
    videoUrl: "https://youtu.be/9fr6geQtd88"
  },
  {
    id: "twenty-six",
    name: "Inner Peace Affirmation",
    category: "Inner Peace",
    steps: [
      "Find a comfortable seated position",
      "Close your eyes and take a few deep breaths",
      "Repeat the affirmation 'I am calm and at peace'",
      "Allow the words to sink into your being",
      "Feel the sense of inner peace growing within you",
      "Continue affirming for the desired duration",
      "When you're ready, gently open your eyes",
      "Carry the affirmation of inner peace with you"
    ],
    videoUrl: "https://youtu.be/F9ArAP7rz_U"
  }
]
;

